import { ComponentType } from 'react';
import styled from 'styled-components';
import { TextInput, TextInputProps } from '../TextInput';

export type DatePickerInputFieldProps = TextInputProps & { keyboardEntryDisabled?: boolean };

export const DatePickerInputField = styled<ComponentType<DatePickerInputFieldProps>>(TextInput)`
    ${(props) => props.keyboardEntryDisabled && `caret-color: transparent`}
`;

export const DatePickerContainerElement = styled.div`
    position: relative;
    flex-grow: 1;
`;

export const DialogedDatePickerElement = styled.div`
    justify-content: center;
    display: flex;
`;
